(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlider(slider) {
      const track = slider.querySelector('.hero__media-track');
      const slides = track ? track.querySelectorAll('.hero__slide') : [];
      const dots = slider.querySelectorAll('.hero__slider-dot');

      if (!track || slides.length <= 1) return;

      let current = 0;
      let autoplayTimer = null;

      function goTo(index) {
        current = (index + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + (current * 100) + '%)';
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === current);
        });
        slides.forEach(function (slide, i) {
          const video = slide.querySelector('video');
          if (!video) return;
          if (i === current) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      }

      function startAutoplay() {
        autoplayTimer = setInterval(function () { goTo(current + 1); }, 5000);
      }

      function resetAutoplay() {
        clearInterval(autoplayTimer);
        startAutoplay();
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i); resetAutoplay(); });
      });

      // Touch swipe (still works without arrows)
      let touchStartX = 0;
      track.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });
      track.addEventListener('touchend', function (e) {
        const diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          goTo(current + (diff > 0 ? 1 : -1));
          resetAutoplay();
        }
      }, { passive: true });

      startAutoplay();
    }

    document.querySelectorAll('[data-hero-slider]').forEach(initSlider);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
